import React, { useState, useEffect } from "react";
import MenuBar from "../../components/atoms/menuBar/MenuBar";
import { PRODUCTS_PATH } from "../../router/Routes";
import {
  ServicesContainer,
  ProductContainer,
} from "../../components/atoms/containers/Containers";
import "./products.css";
import { getProducts } from "../../services";

const Products = () => {
  useEffect(() => {
    document.title = "Aglocol | Productos";
  }, []);

  const [activeProduct, setActiveProduct] = useState({});
  const [selectedService, setSelectedService] = useState(-1);

  const [products, setProducts] = useState([]);

  const changeActiveProduct = (products, index) => {
    setActiveProduct(products[index]);
    setSelectedService(index);
  };

  useEffect(() => {
    getProducts().then((result) => {
      setProducts(result);
      changeActiveProduct(result, 0);
    });
  }, []);

  return (
    <div className="main-container products-background">
      <MenuBar view={PRODUCTS_PATH} />
      <div className="view-content">
        <div className="services-main-container">
          <div className="services-left-container T-compled">
            <ProductContainer product={activeProduct} />
          </div>
          <div className="services-right-container ">
            {products.map((product, index) => (
              <ServicesContainer
                text={product.product}
                callback={() => changeActiveProduct(products, index)}
                active={selectedService === index}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Products;
